import React, { useMemo } from 'react';
import { useTranslation } from '@pascal/pascal-core';
import { observer } from 'mobx-react-lite';
import { globalTranslationKeys } from '../../enums/translationKeys';
import { gameStore } from '../../store/gameStore';
import { FishByType } from '../../core/constants/fishImagesArray';

const FishTableWithOdds = observer(() => {
  const { oddResultTypePair } = gameStore;

  const fishesOdds = useMemo(() => {
    return Object.keys(oddResultTypePair).sort((a, b) => +a - +b);
  }, [oddResultTypePair]);

  return (
    <div className='fs-adds-table-wrapper'>
      <div className='fs-adds-table-wrp'>
        <table className='fs-adds-table'>
          <tbody>
            {fishesOdds.map((fishOdd) => {
              const parsedResultType =
                // eslint-disable-next-line no-nested-ternary
                oddResultTypePair[fishOdd] > 9 && oddResultTypePair[fishOdd] < 15
                  ? oddResultTypePair[fishOdd] - 1
                  : oddResultTypePair[fishOdd] > 15
                  ? oddResultTypePair[fishOdd] - 2
                  : oddResultTypePair[fishOdd];

              const isNotShowThisRow =
                oddResultTypePair[fishOdd] === 10 || oddResultTypePair[fishOdd] === 15;

              return !isNotShowThisRow ? (
                <tr key={fishOdd}>
                  <td className='fish-col' colSpan='4'>
                    <img src={FishByType[parsedResultType]} alt='' />
                  </td>
                  <td colSpan='4'>x{fishOdd}</td>
                </tr>
              ) : (
                <></>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
});

export function HelpPopup() {
  const t = useTranslation();

  return (
    <div className='tb-game-rules-wrapper'>
      <p>{t(globalTranslationKeys.GAME_NAME)}</p>
      <p>{t(globalTranslationKeys.GameRulesP1)}</p>
      <p>{t(globalTranslationKeys.GameRulesP2)}</p>
      <p>{t(globalTranslationKeys.GameRulesP31)}</p>
      <p>{t(globalTranslationKeys.GameRulesP4)}</p>
      <p>{t(globalTranslationKeys.GameRulesP5)}</p>
      <br />
      <p>{t(globalTranslationKeys.GameRulesP6)}</p>
      <p>{t(globalTranslationKeys.GameRulesP7)}</p>
      <p>{t(globalTranslationKeys.GameRulesP41)}</p>
      <p>{t(globalTranslationKeys.GameRulesP8)}</p>
      <p>{t(globalTranslationKeys.GameRulesP21)}</p>
      <p>{t(globalTranslationKeys.GameRulesP9)}</p>
      <FishTableWithOdds />
      <p>{t(globalTranslationKeys.GameRulesP10)}</p>
      <p>
        {t(globalTranslationKeys.CANCELATION_MESSAGE_1)}
        <br />
        {t(globalTranslationKeys.MALFUNCTION_MESSAGE_2)}
      </p>
      <p>{t(globalTranslationKeys.RTP)}</p>
    </div>
  );
}
